/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  $(document).ready(function () {
    setTimeout(function () {
      // Trigger first radio swatch
      const preselected_color = $('.product-page .index-product').attr('data-color');
      if( preselected_color ) {
        $(`radio-swatch input[type='radio'][value='${preselected_color}']`).trigger("click");
      } else {
        $("radio-swatch input[type='radio']").first().trigger("click");
      }
  
      // Remove 'highlighted is-active' from black_1_Front.png thumbnail
      $(".product__thumb__link").each(function () {
        const imageSrc = $(this).data("image-src");
  
        // Check if the image source includes 'black_1_Front.png' and remove the classes
        if (imageSrc && imageSrc.includes("black_1_Front.png")) {
          $(this).closest(".product__thumb").removeClass("highlighted is-active");
          console.log("Removed classes from black_1_Front.png thumb");
        }

        
      });
  
    }, 600); // Adjust delay if needed
  });

  // Swatch image hover
  $('.selector-wrapper__scrollbar').on('click', '.swatches', function (event) {
    event.preventDefault();
    var swatchImageUrl = $(this).data('swatch-image');
    if (swatchImageUrl) {
      $(this)
        .parents('.product-information')
        .prev('.product-item__image')
        .find('.product-item__bg img')
        .attr('src', swatchImageUrl);
    }
  });

  // Highlight matching swatch image on click
  $("radio-swatch").on("click", function () {
    const tooltipValue = $(this).data("tooltip").trim().toLowerCase().replace(/\s+/g, '');
    console.log("Normalized Swatch Tooltip Value:", `"${tooltipValue}"`);

    
    $(".product__thumb__link").each(function () {
      const imageSrc = $(this).data("image-src") ? $(this).data("image-src").trim().toLowerCase().replace(/\s+/g, '') : "";
      // console.log("Normalized Product Photo Image Source:", `"${imageSrc}"`);

      if (imageSrc.includes(tooltipValue)) {
        $(this).parent('.product__thumb').addClass("highlighted");
        // console.log("Class added to:", this);
      } else {
        $(this).parent('.product__thumb').removeClass("highlighted is-active");
      }
    });
  });


  // $("radio-swatch").on("click", function () {
  //   const tooltipValue = $(this).data("tooltip").trim().toLowerCase().replace(/\s+/g, '');
  //   console.log("Clicked swatch tooltip:", tooltipValue);
  
  //   $(".product__thumb__link").each(function () {
  //     const imageSrcRaw = $(this).data("image-src");
  //     const imageSrc = imageSrcRaw ? imageSrcRaw.trim().toLowerCase().replace(/\s+/g, '') : "";
  
  //     // Remove 'highlighted is-active' from specific known image names
  //     if (
  //       imageSrc.includes("black_1_front.png") ||
  //       imageSrc.includes("sand_1_front.png") ||
  //       imageSrc.includes("chocolate_1_front.png") ||
  //       imageSrc.includes("espresso_1_front.png") 
  //     ) {
  //       $(this).closest(".product__thumb").removeClass("highlighted is-active");
  //       console.log("Removed classes from:", imageSrcRaw);
  //     }
  
  //     // Re-apply highlight if the clicked swatch matches image name
  //     // if (imageSrc.includes(tooltipValue)) {
  //     //   $(this).closest(".product__thumb").addClass("highlighted is-active");
  //     //   console.log("Re-highlighted:", imageSrcRaw);
  //     // }
  //   });
  // });


$(document).ready(function () {
  // Active G & Everyday G
  const imagesToRemove = [
    "black1_Front.png", // Added with '4'
    "sand1_Front.png", // Added with '4'
    "chocolate1_Front.png", // Added with '4'
    "blush1_Front.png", // Added with '4'
    "palealmond_Front35345.png", // Added with '4'
    "espresso1_Front.png", // Added with '4'
    
    "black4_Front.png", // Added with '4'
    "sand4_Front.png", // Added with '4'
    "chocolate4_Front.png", // Added with '4'
    "blush2_Front_a4df369d-a2ab-4db8-9381-06df7d42959c.png", // Added with '4'
    "Palealmond4_Front.png", // Added with '4'
    "espresso4_Front.png", // Added with '4'
    "black3_Front_a03ea444-30ae-4305-92ad-8527f67f3163.png",  // Added with '3'
    "sand3_Front_8574fa4d-8261-4c56-875b-6a7d4db97178.png",   // Added with '3'
    "chocolate3_Front_56d05a8c-e68b-4d1c-bbf3-ab00b7c962cd.png", // Added with '3'
    "blush3_Front_ca194721-95b8-40bb-9eb3-19dd611c8f95.png", // Added with '3'
    "palealmond3_Front_d949c44d-5de0-4be2-8a91-515c8536b0cd.png", // Added with '3'
    "espresso3_Front_442f2c4a-48a3-4320-9224-faedb241c594.png",  // Added with '3'
    "black2_Front.png",  // Added with '2'
    "sand2_Front.png",   // Added with '2'
    "chocolate2_Front.png", // Added with '2'
    "blush2_Front.png", // Added with '2'
    "palealmond2_Front.png", // Added with '2'
    "espresso2_Front.png",  // Added with '2'
    "black_1_Front.png",  // Added with '1'
    "sand_1_Front.png",   // Added with '1'
    "chocolate_1_Front.png", // Added with '1'
    "blush_1_Front.png", // Added with '1'
    "palealmond_1_Front.png", // Added with '1'
    "espresso_1_Front.png"  // Added with '1'
  ];

  $('.product__thumb').each(function () {
    const imgSrc = $(this).find('img').attr('src');

    if (imgSrc && imagesToRemove.some(filename => imgSrc.includes(filename))) {
      console.log("Removing .product__thumb with matching image:", imgSrc);
      $(this).remove();
    }
  });
});

  
})();

